import React from 'react';
import '../App.css';

function Contact(props) {
  return (
  <div>
    <div className="container">
    <div className="flex">
    <div className="infobox-1 contact">
    <div class="contact-inner-div">
    <h1>Contact Me</h1>
    <p>Email: berniriscoleman@gmail.com</p>
    <p>Twitter: <a href="https://twitter.com/BernirisAlana" target="_new">@BernirisAlana</a></p>
    <p>LinkedIn: <a href="https://linkedin.com/in/berniris" target="_new">www.linkedin.com/in/berniris</a></p>
    <p>Github: <a href="https://www.github.com/berniris" target="_new">www.github.com/berniris</a></p>
    </div>
    </div>
    </div>
    </div>
    <footer></footer>
</div>
    );
  }
export default Contact;